import PageMaintenance from './PageMaintenance';

export default PageMaintenance;
